module.exports = __webpack_public_path__ + "static/media/well-controlled-asthma-scale-background-adult.eeb1bf83.svg";